export default __webpack_public_path__ + "static/media/ReferralSystemRight.dd9cefba.png";